import React, { useEffect, useState, useRef } from "react";
import { CardHeader, CardBody, Card, Col, Row, Container } from "reactstrap";
import "../../assets/css/admin.css";
import AdminNav from "./AdminNav";
import CustomerCard from "./components/customer";
import XTable from "./components/table";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_ADMINCUSTOMER_DETAILS,
  SET_ADMINCUSTOMER_PLAID_VERIFY,
} from "graphql/admin/mutations/customers";
import { formatDate } from "../../utils/date";
import { useAuth } from "components/custom/authprovider";
import sendMutationContext from "utils/sendContext";
import { SADropdownOrOther } from "utils/functions";
import { CREATE_LOCK_NOTE } from "graphql/admin/mutations/locknotes";
import { SAlert } from "utils/functions";
import { GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID } from "graphql/admin/queries/locknotes";
import { UPDATE_ADMINCUSTOMER_NOTES } from "graphql/admin/mutations/customers";
import { GET_ALL_CUSTOMER_PHONE_NUMBERS } from "graphql/admin/queries/customers";
import Select from "react-select";
import { SimpleFormatPhone } from "utils/functions";
import { lockNotes } from "utils/defaults";
import { UPDATE_ADMINCUSTOMER_CARDBANK } from "graphql/admin/mutations/customers";

function CustomerLookup() {
  const { wt } = useAuth();

  const [logoutFlag, setLogoutFlag] = useState();
  const [phone, setPhone] = useState("");
  const { cphone } = useParams();
  const [inputPhone, setInputPhone] = useState("");
  const history = useHistory();
  const location = useLocation();
  const initialPathRef = useRef(location.pathname);
  const basePath = (() => {
    const current = initialPathRef.current;
    const lastSlashIndex = current.lastIndexOf("/");

    if (current.slice(lastSlashIndex, current.length) == "/customer-lookup") {
      return current + "/";
    }

    return current.slice(0, lastSlashIndex + 1);
  })();

  const [customerPhoneData, setCustomerPhoneData] = useState([]);
  const [customerCards, setCustomerCards] = useState([]);
  const [banklist, setBankList] = useState([]);
  const [getAllCustomerPhoneNumbers] = useLazyQuery(
    GET_ALL_CUSTOMER_PHONE_NUMBERS,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [customer, setCustomer] = useState();
  const [transactionsList, setTransactionsList] = useState();
  const [chargebackLiability, setChargebackLiability] = useState({
    liabilityAmount: 0,
    numberOfLiability: 0,
    disputedAmount: 0,
    numberOfDisputed: 0,
  });

  const [adminCustomerLookup, { loading }] = useMutation(
    GET_ADMINCUSTOMER_DETAILS,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminCustomerSetPlaidVerifyById] = useMutation(
    SET_ADMINCUSTOMER_PLAID_VERIFY,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminCreateLockNote] = useMutation(
    CREATE_LOCK_NOTE,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminGetLastLockNoteByCustomerId] = useLazyQuery(
    GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [updateCustomerNotes] = useMutation(
    UPDATE_ADMINCUSTOMER_NOTES,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [adminUpdateCustomerCardBank] = useMutation(
    UPDATE_ADMINCUSTOMER_CARDBANK,
    sendMutationContext(wt, setLogoutFlag)
  );

  const searchCustomer = async (searchPhone = undefined) => {
    if (!logoutFlag) {
      if (phone !== "") {
        searchPhone = phone;
      }

      if (!searchPhone || searchPhone === "") {
        history.replace({ pathname: basePath });

        setPhone();
        return;
      }

      const data = await adminCustomerLookup({
        variables: { phone: searchPhone },
      });
      if (data.data) {
        const acl = data.data.adminCustomerLookup;

        if (acl.error === null && searchPhone) {
          const customer = acl.customer;
          history.replace({ pathname: basePath + searchPhone });

          adminGetLastLockNoteByCustomerId({
            variables: {
              customerid: customer.customerid,
            },
          }).then((res) => {
            const status =
              res?.data?.getLastLockNoteByCustomerId?.status ?? false;

            if (status) {
              customer.locknote =
                res.data.getLastLockNoteByCustomerId.locknote.reason;
              customer.islock =
                res.data.getLastLockNoteByCustomerId.locknote.islock;
            }

            setCustomer(customer);
          });

          setCustomerCards(acl.cards);
          setBankList(acl.banklist);
          const recentTransactions = acl.recenttransactions
            .slice()
            .filter(
              (transaction) =>
                new Date(transaction.datetimecreated).getTime() >
                new Date().getTime() - 90 * 24 * 60 * 60 * 1000
            );
          const liabilityTransactions = recentTransactions
            .slice()
            .filter((transaction) => !transaction.disputed);
          const disputedTransactions = recentTransactions
            .slice()
            .filter((transaction) => transaction.disputed);
          setChargebackLiability({
            liabilityAmount: liabilityTransactions.reduce(
              (accumulator, currentItem) => {
                return accumulator + currentItem.price;
              },
              0
            ),
            numberOfLiability: liabilityTransactions.length,
            disputedAmount: disputedTransactions.reduce(
              (accumulator, currentItem) => {
                return accumulator + currentItem.price;
              },
              0
            ),
            numberOfDisputed: disputedTransactions.length,
          });
          setTransactionsList(acl.recenttransactions);
        } else {
          history.replace({ pathname: basePath + searchPhone });

          setCustomer();
          setTransactionsList();
        }
      }
    }
  };

  const updateCustomerSearchList = () => {
    getAllCustomerPhoneNumbers().then((res) => {
      setCustomerPhoneData(() => {
        const customers = (
          res?.data?.adminGetAllCustomerPhoneNumbers?.customers ?? []
        )
          .slice()
          .filter((fCustomer) => {
            // Lazy way of dealing with a re-render issue...
            if (customer && fCustomer.customerid === customer.customerid) {
              return customer.active;
            }

            return true;
          })
          .sort((a, b) => (a.lastname || "").localeCompare(b.lastname || ""))
          .map((item) => ({
            value: item.phone,
            label: `${item.phone} - ${item.firstname || ""} ${item.lastname}`,
          }));

        return customers;
      });
    });
  };

  const lockNote = (customer) => {
    const title = customer.isEnabled ? "Lock" : "Unlock";

    SADropdownOrOther(
      `${title} Note`,
      "Select the reason for the lock note",
      "Confirm",
      lockNotes
    ).then((value) => {
      if (value) {
        adminCreateLockNote({
          variables: {
            reason: lockNotes[value] ?? value,
            customerid: customer.customerid,
          },
        })
          .then((res) => {
            const status = res?.data?.createLockNote?.status ?? false;

            if (status) {
              setCustomer((prevCustomer) => {
                return {
                  ...prevCustomer,
                  isEnabled: !prevCustomer.isEnabled,
                  locknote: res.data.createLockNote.locknote.reason,
                  islock: res.data.createLockNote.locknote.islock,
                };
              });
            } else {
              SAlert(
                "Error",
                "There was an error creating the lock note. Please try again.",
                "error"
              );
            }
          })
          .catch(() => {
            SAlert(
              "Error",
              "An error occurred while processing the request. Please try again.",
              "error"
            );
          });
      }
    });
  };

  const setCustomerPlaidVerify = async (customerId) => {
    const req = await adminCustomerSetPlaidVerifyById({
      variables: { id: customerId },
    });

    if (req && req.data && req.data.adminCustomerSetPlaidVerifyById) {
      const status = req.data.adminCustomerSetPlaidVerifyById.status;

      if (status) {
        if (customer.plaidverified) {
          customer.plaidverified = false;
        } else {
          customer.plaidverified = true;
        }

        setCustomer(customer);
      }
    }
  };

  const customSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: state.isFocused ? "blue" : "gray",
      boxShadow: state.isFocused ? "0 0 5px rgba(0, 0, 255, 0.5)" : "none",
      "&:hover": {
        borderColor: "blue",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "lightblue"
        : state.isFocused
        ? "lightblue"
        : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "lightblue",
      },
    }),
  };

  const listHeader = [
    // {
    //   Header: "Internal ID",
    //   accessor: "transactionid",
    //   className: "t-cell-3 text-centered mwTable-15",
    //   disableFilters: true,
    //   disableSortBy: true,
    //   notShowSortingDisplay: true,
    //   Cell: (props) =>(
    //     <span>{props.value}</span>
    //   )
    // },
    {
      Header: "Transaction ID",
      accessor: "ctransid",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => (
        <span>
          <a
            href={"/admin/tools/transaction-lookup/" + props.value}
            className="link bold"
          >
            {props.value}
          </a>
        </span>
      ),
    },
    {
      Header: "Gateway",
      accessor: "gateway",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => <span>{props.value}</span>,
    },
    {
      Header: "DateTime",
      accessor: "datetimecreated",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => <span>{formatDate(props.value)}</span>,
    },
    {
      Header: "Amount",
      accessor: "price",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => <span>{props.value}</span>,
    },
    {
      Header: "Code",
      accessor: "referenceid1",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => <span>{props.value}</span>,
    },
  ];

  useEffect(() => {
    updateCustomerSearchList();
  }, []);

  useEffect(() => {
    if (phone) {
      searchCustomer(phone);
    }
  }, [phone]);

  useEffect(() => {
    if (cphone) {
      setPhone(cphone);
      searchCustomer(cphone);
    }

    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag, history]);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col sm="9">Customer Lookup</Col>

                  <Col sm="3" style={{ textAlign: "right" }}>
                    {customerPhoneData && (
                      <Select
                        options={customerPhoneData}
                        inputValue={inputPhone}
                        styles={customSelectStyle}
                        onChange={(e) => {
                          setPhone(e.value);
                        }}
                        onInputChange={(e) => {
                          if (e.length >= 3 && !isNaN(parseInt(e, 10))) {
                            setInputPhone(SimpleFormatPhone(e));
                            return;
                          }

                          setInputPhone(e);
                        }}
                        isSearchable={true}
                        placeholder={`Customer search`}
                      />
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {!customer && !loading && <span>No customer found!</span>}

                {loading && <span>Searching...</span>}

                {customer && !loading && (
                  <Row>
                    <Col lg="6" md="6" className="customer-card ">
                      {customer.plaidverified && (
                        <CustomerCard
                          banklist={banklist}
                          cards={customerCards}
                          setBankList={setBankList}
                          setCustomerCards={setCustomerCards}
                          customer={customer}
                          setCustomer={setCustomer}
                          lockNote={lockNote}
                          updateCardBank={adminUpdateCustomerCardBank}
                          updateCustomerNotes={updateCustomerNotes}
                          chargebackLiability={chargebackLiability}
                        />
                      )}

                      {!customer.plaidverified && (
                        <CustomerCard
                          banklist={banklist}
                          cards={customerCards}
                          setBankList={setBankList}
                          setCustomerCards={setCustomerCards}
                          customer={customer}
                          setCustomer={setCustomer}
                          lockNote={lockNote}
                          setCustomerPlaidVerify={setCustomerPlaidVerify}
                          updateCardBank={adminUpdateCustomerCardBank}
                          updateCustomerNotes={updateCustomerNotes}
                          chargebackLiability={chargebackLiability}
                        />
                      )}
                    </Col>

                    {/* <Col lg="1" md="1"></Col> */}

                    <Col lg="6" md="6" className="customer-card">
                      <h5 className="section-heading">Recent Transactions</h5>
                      <XTable
                        columns={listHeader}
                        loading={false}
                        data={transactionsList}
                        filterbutton={false}
                      />
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CustomerLookup;
